import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController } from '@ionic/angular';
import { Page } from 'src/app/models/page.model';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { SecondaryToolbarComponent } from 'src/app/shared/components/secondary-toolbar/secondary-toolbar.component';
import { SearchpopoverComponent } from 'src/app/shared/components/searchpopover/searchpopover.component';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { Location, NgIf } from '@angular/common';

@Component({
  selector: 'app-processing-activitydetail',
  templateUrl: './processing-activitydetail.page.html',
  styleUrls: ['./processing-activitydetail.page.scss'],
})
export class ProcessingActivitydetailPage implements OnInit {

  page = new Page();
  showPage: boolean = false;
  category: string;
  companyList: any = [];
  contractPersonList: any = [];
  companyId: string = '';
  contractPersonPrivacyId: string = '';
  contractPersonDataProtectionOfficerId: string ='';
  searchEvent: Subject<any>;
  itemsSelected: any = [];
  columnsWidth: any = [];
  rows = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  preventClick: boolean = true;
  disableSave: boolean;
  processingActivityDocumentId: string = '';
  submitted : boolean = false;

  @ViewChild('secondaryToolBar2') secondary: SecondaryToolbarComponent;
  @ViewChild('table') table: DatatableComponent;

  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Capacity = (40 / 100) * tableWidth;
      this.columnsWidth.ProcessingActivity = (40 / 100) * tableWidth;
      this.columnsWidth.DateModified = (20 / 100) * tableWidth;

    }
    if (this.table && window.innerWidth < 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Capacity = (40 / 100) * tableWidth;
      this.columnsWidth.ProcessingActivity = (40 / 100) * tableWidth;
      this.columnsWidth.DateModified = (20 / 100) * tableWidth;
    }
  }

  constructor(
    private router: Router,
    private _apiService: ApiService,
    public _commonService: CommonService,
    private popoverController: PopoverController,
    private route: ActivatedRoute,
    private location : Location) {
    this.category = "companyDetails";
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.page.orderDir = "desc"
    this.page.orderBy = "modifieddate"
    this.searchEvent = this._commonService.searchTextValue
  }

  ngOnInit() {
  }

  public onLimitChange(limit: any): void {
    this.page.size = parseInt(limit, 10);

    if (this._commonService.searchText && this._commonService.searchText != '') {
      this.setPage({ offset: 0 }, this._commonService.searchText);
    } else {
      this.setPage({ offset: 0 }, '');
    }
  }

  ionViewDidLeave() {
    this.itemsSelected = [];
    this.table.selected = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewWillEnter(){
    this.adjustColumnWidth();
    this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
      setTimeout(() => {
        this.rows = [...this.rows];
        if (this.table) this.table.recalculate();
      }, 0)
    });
    this.resizeSubscription = this._commonService.onResize.subscribe(event => {
      this.adjustColumnWidth();
    });
  }

  ionViewDidEnter() {
    this.processingActivityDocumentId = this.route.snapshot.paramMap.get('id');
    if (this.processingActivityDocumentId == '0') {
      this.processingActivityDocumentId = null;
    }
    this.showPage = true;
    forkJoin([
      this.getCompany(),
      this.getContractPerson(),
    ])
    this.itemsSelected = [];
    if (this.searchEvent) {
      this.searchSubscription = this.searchEvent.subscribe(event => {
        this.setPage({ offset: 0 }, event);
        this._commonService.searchText = event;
      });
    }
    this.setPage({ offset: this._commonService.currentPage ? this._commonService.currentPage : 0 }, this._commonService.searchText && this._commonService.searchText != '' ? this._commonService.searchText : '');
    // this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
    //   setTimeout(() => {
    //     this.rows = [...this.rows];
    //     if (this.table) this.table.recalculate();
    //   }, 0)
    // });
    // this.resizeSubscription = this._commonService.onResize.subscribe(event => {
    //   this.adjustColumnWidth();
    // });

  }


  async getCompany() {
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.getCompanies('', '', '', 0, 0)
      let emptyObj = [{ Name: '', CompanyId: null }];
      let company = emptyObj.concat(res.body);
      this.companyList = company;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async getContractPerson() {
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.getContractPersons('','FirstName','ASC',0,0);
      let emptyObj = [{ FirstName: '', ContractPersonId: null }];
      let contractPerson = emptyObj.concat(res.body);
      this.contractPersonList = contractPerson;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async setPage(pageInfo, searchText) {
    if(this.processingActivityDocumentId != "0" && this.processingActivityDocumentId != null){
      localStorage.setItem('processingActivityDocumentId', this.processingActivityDocumentId);
    this._commonService.searchText = searchText;
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;
    this.table.offset = this.page.pageNumber;
    this._apiService.getProcessingActivityTypesDetail(this.processingActivityDocumentId,searchText ? searchText : "", this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size).then(data => {
      this.page.totalElements = data.headers.get('X-Page-TotalCount');
      if(data.body[0]){
        this.companyId = data.body[0].CompanyId;
        this.contractPersonPrivacyId = data.body[0].ContractPersonPrivacyId;
      this.contractPersonDataProtectionOfficerId = data.body[0].ContractPersonDataProtectionOfficerId
      }

      this.showPage = true;
      this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.table.selected = [];
      if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
      if(data.body[0]){
      this.rows = data.body[0].ProcessingActivityRecords;
      if(this.rows === null){
        this.rows =[];
      }
      }
      this._commonService.log(this.rows, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }
}

  onActivate(event) {
    if (event.type == 'click' && event.cellIndex != 0) {
      if (this.preventClick) {
        this.router.navigate(['processingrecords/' + event.row.ProcessingActivityrecordId]);
      }
    }
    if (event.type == 'checkbox') {
      this.preventClick = false;
      setTimeout(() => {
        this.preventClick = true
      }, 500)
    }
  }

  onSelect(event) {
    let selected = [];
    event.selected.forEach(element => {
      selected.push(element.ProcessingActivityrecordId);
    });
    this.itemsSelected = selected;
  }

  add() {
    this.router.navigate(["processingrecords/0"]);
  }

  delete() {
    if(this.category == 'companyDetails'){
      this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteProcessingActivityDocuments(this.processingActivityDocumentId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
          this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
    }else{
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteProcessingActivityRecords(this.itemsSelected);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.table.selected = [];
          this.itemsSelected = [];
          this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
    }
  }

  async presentSearchPopover(event: any) {
    const popover = await this.popoverController.create({
      component: SearchpopoverComponent,
      event: event,
      translucent: false,
      cssClass: 'searchPopOver'
    });
    return await popover.present();
  }


  goBack() {
    // this.secondary.showSearchContainer = false;
    this._commonService.searchText = '';
    this._commonService.currentPage = 0;
    this._commonService.goBack('processingactivities');
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.page.orderBy = sort.prop.toLowerCase();
    this.page.orderDir = sort.dir;
    this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "add":
        this.add();
        break;
      case "delete":
        this.delete();
        break;
      case "search":
        this.itemsSelected = [];
        this.setPage({ offset: 0 }, obj.Event);
        break;
      case "close":
        this.itemsSelected = [];
        this.setPage({ offset: 0 }, "");
        break;
      case "backToMain":
        this.router.navigate(['dashboard'], { replaceUrl: true });
        break;
      case "back":
        this.goBack();
        break;
        case "download":
        this.downloadTemplate();
        break;
    }
}

onCompanyChanged(event){

}

onContractPersonPrivacyChanged(event){

}

onContractPersonDataProtectionOfficerChanged(event){

}

async onSubmit(){
  this.submitted = true
  this._commonService.presentLoading()
  try {
    let data = {
      CompanyId: this.companyId ? this.companyId : null,
      ContractPersonPrivacyId: this.contractPersonPrivacyId ? this.contractPersonPrivacyId : null,
      ContractPersonDataProtectionOfficerId: this.contractPersonDataProtectionOfficerId ? this.contractPersonDataProtectionOfficerId : null
    }

    if (this.processingActivityDocumentId == "0" || this.processingActivityDocumentId == null) {
      let res = await this._apiService.postProcessingActivityDocuments(data);
      if(res){
        this.processingActivityDocumentId = res.ProcessingActivityDocumentId;
        localStorage.setItem('processingActivityDocumentId', this.processingActivityDocumentId);
          this.location.replaceState('processing-activity/' + this.processingActivityDocumentId);
        }
    } else {
      let res = await this._apiService.putProcessingActivityDocuments(data, this.processingActivityDocumentId);
    }
    this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    this._commonService.log(data, this._commonService.LOG);
    this._commonService.dismiss();
    this.submitted = false;
  } catch (error) {
    this._commonService.dismiss();
    this._commonService.log(error, this._commonService.ERROR)
  }
}
async downloadTemplate() {
  try {
    this._commonService.presentLoading();
    let res = await this._apiService.getDownloadProcessingActivityDocument(this.processingActivityDocumentId);
    var blob = new Blob([res.body], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const fileName = res.headers.get('X-Blob-FileName');

    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);;
    downloadLink.download = fileName;
    downloadLink.click();
    this._commonService.dismiss();
  } catch (error) {
    this._commonService.dismiss();
    this._commonService.log(error, this._commonService.ERROR);
  }
}

}
